export default __webpack_public_path__ + "static/media/membership-banner.268fa584.jpg";